<template>
  <div class="product-card col-lg-3 col-md-4 col-sm-6 my-4">
    <div class="card-content">
      <div class="prod-image">
        <img :src="trash" class="delete-favorite" @click.prevent="DeleteFavorite(product)" width="30" height="30" />
        <img
          :src="product.images.length > 0 ? product.images[0].path : ProductImgDefault"
          :alt="product.name"
          class="img-product"
          @click="goToProduct(product)"
        />
      </div>
      <div class="product-info px-0">
        <span class="gamme mb-2">{{ product.gamme_supplyvet ?? "" }}</span>
        <h3 class="title mb-2" @click="goToProduct(product)">
          {{ product.name }}
        </h3>

        <div class="desc row mx-0">
          <label class="col col-lg-8 px-0">{{
            product.description != null ? truncateHtmlContent(product.description) : ""
          }}</label>
          <span
            v-if="product.variant && product.variant.currentChannelPricings"
            class="price my-auto col col-lg-4 px-0"
          >
            {{ formatPrice(isClient ? product.variant.price_ttc : product.variant.price_ht) }}
            <span>{{ isClient ? '€ TTC' : '€ HT' }}</span>
          </span>
        </div>
        <button class="btn text-white product-more w-100 mt-2" @click="goToProduct(product)">En savoir plus</button>
      </div>
    </div>
  </div>
</template>

<script>
  import trash from "@/assets/trash.svg";
  import ProductImgDefault from "@/assets/images/product_default.png";
  import { useProductsStore } from "@/stores/productsStore";
  import { useRegisterStore } from '@/stores/register';

  export default {
    data() {
      return {
        trash,
        ProductImgDefault,
        productsStore: null,
      };
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    created() {
      // Initialisation du store de produits
      this.productsStore = useProductsStore();
      this.registerStore = useRegisterStore();
    },
     computed: {
      isClient() {
        return this.registerStore.user?.role === "client";
      },
    },
    methods: {
      DeleteFavorite(prod) {
        prod.has_favorite = !prod.has_favorite;
        this.productsStore.RemoveFavoriteProduct(prod);
      },
      truncateHtmlContent(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const plainText = tempDiv.textContent || tempDiv.innerText || "";
        return plainText.length > 60 ? plainText.slice(0, 60) + "..." : plainText;
      },
      goToProduct(prod) {
        var slug = prod.slug;
        this.$router.push({ name: "ProductDetail", params: { slug } });
      },

      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value) / 100;
        return num.toFixed(2).replace('.', ',');
      }
    },
  };
</script>
<style scoped>
  .product-card {
    text-align: left;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .product-card .prod-image {
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 10px 10px 0 0;
    background: #fff;
  }

  .product-card .product-info {
    padding: 8px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .product-card .gamme {
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    text-align: left;
    color: #1e347d;
    height: 20px;
    overflow: hidden;
  }

  .product-card .title {
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    text-align: left;
    color: #1e347d;
    height: max-content;
    cursor: pointer;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.2;
  }

  .product-card .desc {
    text-align: left;
    height: 45px;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
  }

  .product-card .desc label {
    font-size: 15px;
  }

  .prod-image .img-product {
    cursor: pointer;
    min-height: 228px;
  }

  .product-card img {
    max-width: 100%;
    height: auto;
  }

  .product-card .delete-favorite {
    float: right;
    cursor: pointer;
  }

  .price {
    font-weight: bold;
    font-size: 19px;
    color: #1e347d;
    text-align: right;
  }

  .price span {
    font-size: 14px;
  }

  .product-more {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 15px;
    text-align: center;
    margin-top: auto;
  }

  @media (min-width: 768px) and (max-width: 1367px) {
    .product-card .title {
      font-size: 14px;
    }
    .product-card .desc label {
      font-size: 12px;
    }
    .price {
      font-weight: 600;
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    .product-card .title {
      font-size: 13px;
    }
    .product-card .desc label {
      font-size: 12px;
    }
    .price {
      font-weight: 600;
      font-size: 12px;
    }
  }
</style>
